export function TargetWomenIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g transform="translate(8.5 2)">
        <g id="Group">
        <path id="Vector" d="M7.57143 10.1429C10.0962 10.1429 12.1429 8.09616 12.1429 5.57143C12.1429 3.0467 10.0962 1 7.57143 1C5.0467 1 3 3.0467 3 5.57143C3 8.09616 5.0467 10.1429 7.57143 10.1429Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path id="Vector_2" d="M7.5 14C1 14 1 27 1 27H14C14 27 14 14 7.5 14Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
    </svg>
  )
}
